import { createActions, createReducer } from 'reduxsauce'

import ConsultaProvimentosMembrosService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaProvimentosMembrosInicio: [],
    buscaConsultaProvimentosMembrosErro: ['erro'],
    buscaConsultaProvimentosMembrosSucesso: ['consultaProvimentosMembros'],
    limpar: [],
    setConsultaProvimentosMembrosEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaProvimentosMembros = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaProvimentosMembrosInicio())
        let serv = new ConsultaProvimentosMembrosService()
        return serv
            .consultarProvimentos(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaProvimentosMembrosSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaProvimentosMembrosErro(error)))
    }
}

const buscaConsultaProvimentosMembrosInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaProvimentosMembrosErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaProvimentosMembrosSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaProvimentosMembros.resultado,
        dataSincronizacaoDados: action.consultaProvimentosMembros.dataSincronizacaoDados,
        carregando: false,
        fonte: action.consultaProvimentosMembros.fonte,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaProvimentosMembrosEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_PROVIMENTOS_MEMBROS_INICIO]: buscaConsultaProvimentosMembrosInicio,
    [Types.BUSCA_CONSULTA_PROVIMENTOS_MEMBROS_ERRO]: buscaConsultaProvimentosMembrosErro,
    [Types.BUSCA_CONSULTA_PROVIMENTOS_MEMBROS_SUCESSO]: buscaConsultaProvimentosMembrosSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_PROVIMENTOS_MEMBROS_ESTADO_DT]: setConsultaProvimentosMembrosEstadoDT,
})
